<h2 mat-dialog-title class="sad-title">Stationen zuweisen</h2>

<mat-dialog-content>
  <div class="assignment-target-panel">
    <div class="sad-head">
      <div>
        <div class="fw-semibold text-secondary">Zuweisungsfilter</div>
        <small class="text-secondary">Je Station lassen sich die ansteuerbaren Typen einzeln zuweisen.</small>
      </div>
      <div class="sad-head-actions">
        <span class="small fw-semibold">{{ selectedStationCount }} von {{ data.stations.length }} Stationen</span>
        <button class="btn btn-sm btn-link p-0" type="button" (click)="selectAll()">Alle</button>
        <button class="btn btn-sm btn-link p-0 text-danger" type="button" (click)="clear()">Keine</button>
      </div>
    </div>

    <div class="small fw-semibold text-secondary mb-1">Stationen</div>
    <div class="station-target-list" *ngIf="data.stations.length > 0; else noStations">
      <ng-container *ngFor="let group of displayGroups; trackBy: trackByGroup">
        <label class="sad-group-header" [class.assignment-option-disabled]="stationsForGroup(group).length < 1">
          <input class="form-check-input mt-0" type="checkbox"
            [checked]="isGroupSelected(group)" [indeterminate]="isGroupPartial(group)"
            [disabled]="stationsForGroup(group).length < 1"
            (change)="onGroupChanged(group, $any($event.target).checked)">
          <span>{{ group.name || group.routeName || ('Gruppe ' + group.id) }}
            <small class="text-secondary">({{ stationsForGroup(group).length }})</small></span>
        </label>
        <div class="station-row" *ngFor="let station of stationsInGroup(group); trackBy: trackByStation">
          <span class="station-row-text">
            <avs-station-meta-info [metaInformation]="metaFor(station)" [x]="station.x" [y]="station.y" layout="inline"></avs-station-meta-info>
            <span class="fw-semibold">{{ station.name }}</span>
          </span>
          <span class="station-row-types" *ngIf="drivableTypes(station).length > 0; else noTypes">
            <button type="button" class="sad-type-block" *ngFor="let t of drivableTypes(station)"
              [class.sad-type-off]="!isTypeSelected(station, t)"
              [style.background]="isTypeSelected(station, t) ? typeColor(t).color : 'transparent'"
              [style.color]="isTypeSelected(station, t) ? typeColor(t).text : '#888'"
              [style.borderColor]="typeColor(t).color"
              (click)="toggleType(station, t)">{{ t }}</button>
          </span>
          <ng-template #noTypes><small class="text-secondary">keine passenden Kanäle</small></ng-template>
        </div>
      </ng-container>
    </div>
    <ng-template #noStations>
      <p class="text-secondary small m-0">Keine Stationen vorhanden.</p>
    </ng-template>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button class="btn btn-sm btn-outline-secondary rounded-0" type="button" (click)="cancel()">Abbrechen</button>
  <button class="btn btn-sm btn-danger rounded-0" type="button" (click)="confirm()">Übernehmen</button>
</mat-dialog-actions>
